import Vue3SocialSharingPlugin from "vue3-social-sharing";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Vue3SocialSharingPlugin)
})
